import React from 'react';
import { useSelector } from 'react-redux';
import useImpersonation from '../../../hooks/useImpersonation';

// Red frame around the whole screen plus a "screen sharing" style tab at the
// top, shown while an admin is signed in as another user. Sits above the
// product tour overlay (z-index 10000) so Stop is always reachable.
const ImpersonationBanner = () => {
  const { userDetails } = useSelector((state) => state?.userDetails);
  const { exitImpersonation } = useImpersonation();

  if (!userDetails?.impersonating) {
    return null;
  }

  return (
    <>
      <div className='fixed inset-0 border-4 border-error-500 pointer-events-none z-[10001]' />

      <div className='fixed top-0 left-1/2 -translate-x-1/2 z-[10001] flex flex-row items-center gap-x-3 max-w-[95%] bg-error-500 text-white text-sm rounded-b-md shadow-md px-3 py-1'>
        <span className='truncate'>
          Impersonating{' '}
          <span className='font-semibold'>{userDetails?.user?.first_name}</span>{' '}
          ({userDetails?.user?.email})
        </span>

        <button
          onClick={exitImpersonation}
          className='flex-shrink-0 bg-white text-error-600 font-medium text-xs rounded px-2 py-0.5 hover:bg-error-50'
        >
          Stop
        </button>
      </div>
    </>
  );
};

export default ImpersonationBanner;
